import script from "./CoverPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CoverPage.vue?vue&type=script&setup=true&lang=ts"

import "./CoverPage.vue?vue&type=style&index=0&id=524d108b&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_354139e77772094841bf527df78bd682/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-524d108b"]])

export default __exports__